export const FIELD_TYPE = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  DDL_STAKEHOLDER: 'DDL_STAKEHOLDER',
  DDL_DRUG: 'DDL_DRUG',
  DDL_STAKEHOLDER_TYPE: 'DDL_STAKEHOLDER_TYPE',
  DDL_ESTABLISHMENT: 'DDL_ESTABLISHMENT',
  DATE_PICKER: 'DATE_PICKER',
  CHECKBOX: 'CHECKBOX',
  DDL_RECALL_PRODUCT_LEVEL: 'DDL_RECALL_PRODUCT_LEVEL',
  DDL_RECALL_LEVEL: 'DDL_RECALL_LEVEL',
  DDL_OPERATION: 'DDL_OPERATION',
  DDL_REGION: 'DDL_REGION',
  DDL_CITY: 'DDL_CITY',
  DDL_SUBSCRIPTION_PACKAGE: 'DDL_SUBSCRIPTION_PACKAGE',
  DDL_ACTIVE_PASSIVE_SELECT: 'DDL_ACTIVE_PASSIVE_SELECT ',
  DDL_DRUGS_REQUESTS_STATUS: 'DDL_DRUGS_REQUESTS_STATUS',
  DDL_UNREGISTERED_DRUG_REQUEST_TYPE: 'DDL_UNREGISTERED_DRUG_REQUEST_TYPE',
  DDL_DOMAINS: 'DDL_DOMAINS',
  DDL_COUNTRY_OF_MANUFACTURER: 'DDL_COUNTRY_OF_MANUFACTURER',
  DDL_YES_NO: 'DDL_YES_NO',
  DDL_LAGAL_STATUS: 'DDL_LAGAL_STATUS',
  DDL_CONTROL_LEVEL: 'DDL_CONTROL_LEVEL',
  DDL_AUTHORIZATION_STATUS: 'DDL_AUTHORIZATION_STATUS',
  DDL_MARKETING_STATUS: 'DDL_MARKETING_STATUS',
  DDL_STORAGE_CONDITIONS: 'DDL_STORAGE_CONDITIONS',
  DDL_STRENGTH_VALUE_UNIT: 'DDL_STRENGTH_VALUE_UNIT',
  DDL_UNIT_OF_VOLUME: 'DDL_UNIT_OF_VOLUME',
  LABELED_TEXT_AREA: 'LABELED_TEXT_AREA',
  DDL_DRUG_GENERIC_NAME: 'DDL_DRUG_GENERIC_NAME',
  GENERIC_NAME_DDL_OR_TEXT: 'GENERIC_NAME_DDL_OR_TEXT',
  FILES: 'FILES',
  DDL_LABEL_LEVEL_TYPES: 'DDL_LABEL_LEVEL_TYPES',
  DDL_LABEL_NAME: 'DDL_LABEL_NAME',
  DDL_SUBSCRIPTION_TYPE: 'DDL_SUBSCRIPTION_TYPE',
  DDL_STAKEHOLDER_BY_SUBSCRIPTION: 'DDL_STAKEHOLDER_BY_SUBSCRIPTION',
  DDL_EXPIRY_PRIORITY: 'DDL_EXPIRY_PRIORITY'
};
